import { WeightSchema } from "@redotech/redo-model/outbound-labels/util";
import { RateSchema_ } from "@redotech/redo-model/shipment";
import { AddressSchema } from "@redotech/redo-model/team";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { PurchaseLabelType } from "./purchase-label";

export const getLabelRates = {
  name: "getLabelRates" as const,
  input: z.object({
    teamId: z.string(),
    returnId: z.string(),
    fromAddress: AddressSchema,
    toAddress: AddressSchema,
    weight: WeightSchema,
    originalShipmentId: z.string().optional(),
    labelType: createEnum(PurchaseLabelType),
  }),
  output: z.object({
    rates: z.array(RateSchema_),
    originalLabelCost: z.number(),
  }),
};
